import { render, staticRenderFns } from "./EvInitDayWheel.vue?vue&type=template&id=22ac639e&scoped=true"
import script from "./EvInitDayWheel.vue?vue&type=script&lang=js"
export * from "./EvInitDayWheel.vue?vue&type=script&lang=js"
import style0 from "./EvInitDayWheel.vue?vue&type=style&index=0&id=22ac639e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac639e",
  null
  
)

export default component.exports